import { use } from 'react';

import { AuthContext, type AuthContextValue } from './AuthContext.ts';

export function useAuth(): AuthContextValue {
  const context = use(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used inside an <AuthProvider>.');
  }

  return context;
}
